import { Star } from "lucide-react";

interface StarRatingProps {
  avgPerMonth: number;
}

export function StarRating({ avgPerMonth }: StarRatingProps) {
  // Calculate stars based on avgPerMonth
  let stars: number;
  if (avgPerMonth >= 81) {
    stars = 5;
  } else if (avgPerMonth >= 21) {
    stars = 4.5;
  } else if (avgPerMonth >= 11) {
    stars = 4;
  } else if (avgPerMonth >= 6) {
    stars = 3;
  } else {
    stars = 2;
  }

  const fullStars = Math.floor(stars);
  const hasHalfStar = stars % 1 !== 0;

  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="relative">
          {/* Background star */}
          <Star className="w-4 h-4 text-gray-300" fill="currentColor" />
          {/* Filled star overlay */}
          {i < fullStars && (
            <div className="absolute inset-0">
              <Star className="w-4 h-4 text-yellow-400" fill="currentColor" />
            </div>
          )}
          {/* Half star */}
          {hasHalfStar && i === fullStars && (
            <div className="absolute inset-0 overflow-hidden w-1/2">
              <Star className="w-4 h-4 text-yellow-400" fill="currentColor" />
            </div>
          )}
        </div>
      ))}
      <span className="text-sm text-gray-400 ml-2">{stars.toFixed(1)}</span>
    </div>
  );
}
